import { useNavigate, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import ErrorStatePage from "@/pages/ErrorState/ErrorStatePage";

export default function NotFound() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleGoHome = () => {
    navigate("/");
  };

  const handleRetry = () => {
    // Reload the current page
    window.location.reload();
  };

  return (
    <>
      {/* SEO */}
      <Helmet>
        <title>404 | Page Not Found - Storemandu</title>
        <meta
          name="description"
          content="The page you're looking for doesn't exist."
        />
      </Helmet>

      <ErrorStatePage
        statusCode={404}
        title="Page not found"
        description="The page you're looking for doesn't exist or the link is incorrect."
        errorPayload={{
          type: "ROUTE_NOT_FOUND",
          path: location.pathname,
          timestamp: new Date().toISOString(),
        }}
        onGoHome={handleGoHome}
        onRetry={handleRetry}
      />
    </>
  );
}
